document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-df-qty]').forEach(function(wrap){
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var n = parseInt(input.value || '1', 10);
        n += btn.dataset.action === 'plus' ? 1 : -1;
        input.value = Math.max(1, n);
      });
    });
  });
  var menu = document.querySelector('[data-df-mobile-menu]');
  var toggle = document.querySelector('[data-df-menu-toggle]');
  if(menu && toggle){
    toggle.addEventListener('click', function(){
      var open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', open ? 'false' : 'true');
      menu.style.display = open ? 'none' : 'grid';
    });
  }
});
